import { render } from "./RefreshIcon.vue?vue&type=template&id=7ce6aabe"
import script from "./RefreshIcon.vue?vue&type=script&lang=ts"
export * from "./RefreshIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script